import {atomWithStorage} from "jotai/utils";

const seenProductsAtom = atomWithStorage("seen_products", []); // Auto-syncs with localStorage

export {seenProductsAtom};
